export const UserSuper = {
	url: '/super',
	title: 'User Super',
	template: '<super-page></super-page>',
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "userSuperPageMod" */
			'@Containers/user-super-page/super-page.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
